// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!./shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner-wrapper {
  padding: 3rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.spinner {
  width: 5rem;
  height: 5rem;
  margin-bottom: 1rem;
}

.cls-1 {
  fill: var(--white);
}

.cls-2 {
  fill: var(--green1);
}

.cls-7 {
  fill: var(--red1);
}

.cls-8 {
  fill: var(--orange3);
}

.cls-10 {
  fill: var(--red3);
}

.cls-12 {
  fill: var(--blue2);
}

.cls-13 {
  fill: var(--red2);
}

.cls-9 {
  fill: var(--green3);
}

.cls-3 {
  fill: var(--orange1);
}

.cls-6 {
  fill: var(--orange2);
}

.cls-4 {
  fill: var(--green2);
}

.cls-11 {
  fill: var(--blue3);
}

.cls-5 {
  fill: var(--blue1);
}

.anim {
  animation: loading-animation 0.8s infinite ease-in-out;
}

.anim.anim1 {
    animation-delay: 0s;
  }

.anim.anim2 {
    animation-delay: 0.1s;
  }

.anim.anim3 {
    animation-delay: 0.2s;
  }

.anim.anim4 {
    animation-delay: 0.4s;
  }

.anim.anim5 {
    animation-delay: 0.5s;
  }

.anim.anim6 {
    animation-delay: 0.6s;
  }

@keyframes loading-animation {
  0%, 40%, 100% {
    opacity: 1;
  }
  20% {
    opacity: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./core/components/Loading.css"],"names":[],"mappings":"AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sDAAsD;AAyBxD;;AAvBE;IACE,mBAAmB;EACrB;;AAEA;IACE,qBAAqB;EACvB;;AAEA;IACE,qBAAqB;EACvB;;AAEA;IACE,qBAAqB;EACvB;;AAEA;IACE,qBAAqB;EACvB;;AAEA;IACE,qBAAqB;EACvB;;AAGF;EACE;IACE,UAAa;EACf;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":["@import \"shared.css\";\r\n\r\n.spinner-wrapper {\r\n  padding: 3rem;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n}\r\n\r\n.spinner {\r\n  width: 5rem;\r\n  height: 5rem;\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.cls-1 {\r\n  fill: var(--white);\r\n}\r\n\r\n.cls-2 {\r\n  fill: var(--green1);\r\n}\r\n\r\n.cls-7 {\r\n  fill: var(--red1);\r\n}\r\n\r\n.cls-8 {\r\n  fill: var(--orange3);\r\n}\r\n\r\n.cls-10 {\r\n  fill: var(--red3);\r\n}\r\n\r\n.cls-12 {\r\n  fill: var(--blue2);\r\n}\r\n\r\n.cls-13 {\r\n  fill: var(--red2);\r\n}\r\n\r\n.cls-9 {\r\n  fill: var(--green3);\r\n}\r\n\r\n.cls-3 {\r\n  fill: var(--orange1);\r\n}\r\n\r\n.cls-6 {\r\n  fill: var(--orange2);\r\n}\r\n\r\n.cls-4 {\r\n  fill: var(--green2);\r\n}\r\n\r\n.cls-11 {\r\n  fill: var(--blue3);\r\n}\r\n\r\n.cls-5 {\r\n  fill: var(--blue1);\r\n}\r\n\r\n.anim {\r\n  animation: loading-animation 0.8s infinite ease-in-out;\r\n\r\n  &.anim1 {\r\n    animation-delay: 0s;\r\n  }\r\n\r\n  &.anim2 {\r\n    animation-delay: 0.1s;\r\n  }\r\n\r\n  &.anim3 {\r\n    animation-delay: 0.2s;\r\n  }\r\n\r\n  &.anim4 {\r\n    animation-delay: 0.4s;\r\n  }\r\n\r\n  &.anim5 {\r\n    animation-delay: 0.5s;\r\n  }\r\n\r\n  &.anim6 {\r\n    animation-delay: 0.6s;\r\n  }\r\n}\r\n\r\n@keyframes loading-animation {\r\n  0%, 40%, 100% {\r\n    opacity: 100%;\r\n  }\r\n  20% {\r\n    opacity: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
